import Axios from 'axios';

const API_TOKEN_HEADER = 'DPB-API-KEY';
const CURRENT_HOST = window.location.host;
const CURRENT_SCHEME = window.location.protocol;
export const LOCAL_STORAGE_TOKEN = 'token';

export const axios = Axios.create({
    baseURL: CURRENT_HOST.includes('localhost') ? 'http://localhost:8003' : `${CURRENT_SCHEME}//${CURRENT_HOST}/api`,
});

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem(LOCAL_STORAGE_TOKEN) || '';

        config.headers.Accept = 'application/json';
        config.headers['Access-Control-Allow-Origin'] = '*';

        if (token) {
            config.headers[API_TOKEN_HEADER] = token;
        }

        return config;
    },
    (error) => Promise.reject(error?.response?.data?.detail || error?.response?.data || error)
);

axios.interceptors.response.use(
    (response) => {
        return response.data ?? response;
    },
    async (error) => Promise.reject(error?.response?.data?.detail || error?.response?.data || error)
);
